export default __webpack_public_path__ + "static/media/thankyoukeyvis_voucher100_mob@2x.4b3795b5.png";